var _desc, _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomSoftware(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 360",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Custom Software Development") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Puzzle-like modular blocks forming tailored software.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0f3656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#061b2c"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    rx: 18,
    fill: "url(#bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(120 70)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 124,
    height: 104,
    rx: 14,
    fill: "#1a608f"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 0,
    width: 124,
    height: 104,
    rx: 14,
    fill: "#14507a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 0,
    width: 124,
    height: 104,
    rx: 14,
    fill: "#0f3f61"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 116,
    width: 124,
    height: 104,
    rx: 14,
    fill: "#113b59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 116,
    width: 124,
    height: 104,
    rx: 14,
    fill: "#1f6ea2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 116,
    width: 124,
    height: 104,
    rx: 14,
    fill: "#174f77"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 52,
    r: 18,
    fill: "#ffd700"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 168,
    r: 18,
    fill: "#9bd8ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 168,
    r: 18,
    fill: "#7de0bf"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomSoftware);
export default __webpack_public_path__ + "static/media/custom-software.6a51d2231957f8e568356776c081e6dd.svg";
export { ForwardRef as ReactComponent };